import React from "react";
import { color, radius, weight } from "../tokens";

/**
 * <LiveDot> — small breathing dot + "LIVE" label, used in role-panel
 * headers to signal realtime data without a giant chip. Replaces the old
 * pulsing status pill that used to hang out in card corners.
 *
 *   color : hex — the accent color for the dot (usually the role color)
 *   label : string — override the "LIVE" label (e.g. "STREAMING")
 */
export function LiveDot({ color: dotColor = color.role.live.solid, label = "Live" }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 11,
        color: color.text.muted,
        fontWeight: weight.medium,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: radius.pill,
          background: dotColor,
          boxShadow: `0 0 0 3px ${dotColor}22`,
          animation: "idz-pulse 1.6s ease-in-out infinite",
        }}
      />
      {label}
    </span>
  );
}
